import React from "react";
import { Label } from "@fluentui/react";
import { useCommonControlsStyle } from "../../../theme/styles/CommonControlsStyle";
import logicalUnitImage from "../../../assets/luError.png";

const containerStyle = {
  padding: "10px auto",
  bottom: "50px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "90vh",
};

const messageStyle = {
  margin: "auto",
  width: "400px",
  paddingLeft: "0px",
};

const imageStyle = {
  maxWidth: "100%",
  maxHeight: "80%",
  width: "300px",
  height: "300px",
  objectFit: "contain",
  objectPosition: "center",
};

export function CheckInNewListErrorDisplay({ message }) {
  const styleTheme = useCommonControlsStyle();

  return (
    <div style={containerStyle}>
      <div style={messageStyle}>
        <Label style={styleTheme.LabelErrorMessageStyle}>
          {message ?? ""}
        </Label>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            id="mainPageBackground"
            src={logicalUnitImage}
            style={imageStyle}
            alt="Error"
          />
        </div>
      </div>
    </div>
  );
}
